var map = {
	"./57.mp3": "658f",
	"./58.mp3": "bd72",
	"./59.mp3": "e767",
	"./60.mp3": "8b76",
	"./61.mp3": "78da",
	"./62.mp3": "1585",
	"./63.mp3": "2041",
	"./64.mp3": "b6eb",
	"./65.mp3": "7e77",
	"./66.mp3": "3364",
	"./67.mp3": "784f",
	"./68.mp3": "d173",
	"./69.mp3": "07af",
	"./70.mp3": "1944",
	"./M_Brilliant.mp3": "5125",
	"./M_Excellent.mp3": "7b3b",
	"./M_Fantastic.mp3": "52a8",
	"./M_Great.mp3": "db28",
	"./M_Perfect.mp3": "bb48",
	"./M_Think again.mp3": "0316",
	"./M_Try again.mp3": "9617",
	"./M_Very good.mp3": "2ff7",
	"./M_Well done.mp3": "90a2",
	"./M_Work harder.mp3": "0110",
	"./click.mp3": "a287",
	"./false.mp3": "b848",
	"./true.mp3": "3bdd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "429c";